import React from "react";
import { MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
export const FloatingButton = ({ onClick, unreadCount = 0, widgetConfig }) => {
  const { t } = useTranslation();
  const companyName = widgetConfig?.company_name || t("widget.title");

  return (
    <button
      onClick={onClick}
      className="gpc-floating-button gpc-floating-button-with-text gpc-animate-fade-in"
      aria-label={t("chat.title")}
      title={t("chat.title")}
    >
      <div className="gpc-floating-content">
        <MessageCircle className="gpc-floating-icon" />
        <span className="gpc-floating-text">{t("widget.questionsTo")} {companyName}</span>
      </div>

      {unreadCount > 0 && (
        <span className="gpc-notification-badge">
          {unreadCount > 9 ? "9+" : unreadCount}
        </span>
      )}
    </button>
  );
};